var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "ranking-export-actions",
      attrs: { "data-testid": "ranking-export-actions" },
    },
    [
      _c(
        "a",
        {
          class: ["export-link", { "export-link--disabled": _vm.isDisabled }],
          attrs: { "data-testid": "export-image-link" },
          on: {
            click: function ($event) {
              $event.preventDefault()
              !_vm.isDisabled && _vm.$emit("export-image")
            },
          },
        },
        [_vm._v("\n    " + _vm._s(_vm.$t("save_as_image")) + "\n  ")]
      ),
      _vm._v(" "),
      _c("span", { staticClass: "export-separator" }, [_vm._v("/")]),
      _vm._v(" "),
      _c(
        "a",
        {
          class: ["export-link", { "export-link--disabled": _vm.isDisabled }],
          attrs: { "data-testid": "export-csv-link" },
          on: {
            click: function ($event) {
              $event.preventDefault()
              !_vm.isDisabled && _vm.$emit("export-csv")
            },
          },
        },
        [_vm._v("\n    " + _vm._s(_vm.$t("save_as_csv")) + "\n  ")]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }